export class Mail {
  sender: string;
  senderName: string;
  title: string;
  body: string;
}
